var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.51291 1.82312C6.93805 0.324612 9.06195 0.324612 9.48709 1.82312C9.75941 2.78294 10.8561 3.23722 11.7274 2.75108C13.0876 1.9921 14.5894 3.49392 13.8305 4.85415C13.3443 5.7254 13.7986 6.82214 14.7584 7.09445C16.2569 7.51959 16.2569 9.64349 14.7584 10.0686C13.7986 10.3409 13.3443 11.4377 13.8305 12.3089C14.5894 13.6692 13.0876 15.171 11.7274 14.412C10.8561 13.9259 9.75941 14.3801 9.48709 15.34C9.06195 16.8385 6.93805 16.8385 6.51291 15.34C6.24059 14.3801 5.14385 13.9259 4.27261 14.412C2.91238 15.171 1.41056 13.6692 2.16954 12.3089C2.65568 11.4377 2.20139 10.3409 1.24158 10.0686C-0.256931 9.64349 -0.256931 7.51959 1.24158 7.09445C2.20139 6.82214 2.65568 5.7254 2.16954 4.85415C1.41056 3.49392 2.91238 1.9921 4.27261 2.75108C5.14385 3.23722 6.24059 2.78294 6.51291 1.82312Z",
    fill: "#FF3E6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar19);
export default __webpack_public_path__ + "static/media/star-1-9.60a07f5e68686138b207f1a21dd3f96d.svg";
export { ForwardRef as ReactComponent };